export const languages = [
  {
    code: 'pl',
    label: 'Polski',
    country_code: 'pl',
    display_code: 'PL',
  },
  {
    code: 'en',
    label: 'English',
    country_code: 'gb',
    display_code: 'EN',
  },
  {
    code: 'uk',
    label: 'Yкраїнський',
    country_code: 'uk',
    display_code: 'UA',
  },
  {
    code: 'ru',
    label: 'Rосійською',
    country_code: 'ru',
    display_code: 'RU',
  },
];
